<ion-content>
  <app-center-notice text="ページが見つかりません"></app-center-notice>
</ion-content>
